const commonRoutes = [
  {
    path: "/parameters",
    name: "Parameters",
    icon: "icon cafe-options",
  },
];

export default commonRoutes;
